export default "__VITE_ASSET__482d5ee1__"